import { t } from '@i18n';
import { org_sector_type_enum, role_enum } from '@predium/enums';
import { translateRoleEnum_dynamic } from '@predium/i18n/client';

export const isPrediumEmployee = (email: string | null | undefined): boolean => {
  return email?.toLowerCase().endsWith('@predium.de') ?? false;
};

export type RoleOption = { name: role_enum | 'all'; displayName: string };

export const RoleSortingOptions = (orgSector: org_sector_type_enum): Array<RoleOption> => {
  const userRole = orgSector === org_sector_type_enum.BANKING ? role_enum.BANKING_USER : role_enum.USER;

  return [
    { name: 'all', displayName: t('General_AllRoles') },
    { name: role_enum.ORG_ADMIN, displayName: translateRoleEnum_dynamic(role_enum.ORG_ADMIN) },
    { name: userRole, displayName: translateRoleEnum_dynamic(userRole) },
  ];
};
